<template>
  <div class="view login">
    <div class="container">
      <h1 class="h2">Identification à l’aide de votre numéro de commande</h1>
      <p class="text">Ce numéro de commande vous a été envoyé par email lors de la confirmation de votre commande.</p>

      <form
        v-for="form in forms"
        :key="`form-${form.type}`"
        @submit.prevent="onSubmit(form.type)"
        class="view-form"
        novalidate
      >
        <p
          v-if="error"
          class="error"
        >
          Les informations encodées ne correspondent à aucun compte
        </p>
        <field
          v-for="field in form.fields"
          :key="`field-${field.name}`"
          :id="`field-${field.name}`"
          :label="field.label"
          :type="field.type || 'text'"
          :description="field.description"
          :value="fields[field.name]"
          :error="field.error"
          :placeholder="field.placeholder"
          @input="onInput($event, field.name)"
        />

        <div class="view-form-actions">
          <btn
            :type="'submit'"
          >
            Se connecter
          </btn>
        </div>
      </form>

      <div  v-if="loading" class="loader-container">
        <loader/>
      </div>
    </div>
  </div>
</template>

<script>
import Btn from '@/components/components/Btn.vue';
import Loader from '@/components/components/Loader.vue';
import Field from '@/components/modules/Field.vue';
// Data
import login from '@/data/static/login.json';

export default {
  components: {
    Btn,
    Loader,
    Field
  },
  data() {
    return {
      forms: [...login.forms]
    };
  },
  computed: {
    fields() {
      return this.$store.state.login.fields;
    },
    error() {
      return this.$store.state.login.error;
    },
    loading() {
      return this.$store.state.login.requests !== 0;
    }
  },
  methods: {
    validate(type) {
      let valid = true;
      const form = this.forms.filter(f => f.type === type)[0];

      form.fields.map(field => {
        const value = this.fields[field.name];
        if (!value || value.length === 0) {
          field.error = 'Ce champ est requis';
          valid = false;
        } else {
          // eslint-disable-next-line
          if (field.validation) {
            const regex = new RegExp(field.validation.regex, 'i');
            const match = regex.test(value);

            if (match) {
              field.error = null;
            } else {
              field.error = field.validation.message;
              valid = false;
            }
          } else {
            field.error = null;
          }
        }

        return field;
      });

      return valid;
    },
    // Events
    onInput($event, type) {
      this.$store.commit('login/updateField', {
        value: $event,
        type
      });
    },
    onSubmit(type) {
      const valid = this.validate(type);

      if (valid) {
        this.$store.dispatch('login/authenticate');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.view {
  @include padding(null null 38px);
  position: relative;

  .h2 {
    @include margin(null null 12px);
  }

  .text {
    @include margin(null null 21px);
    font-size: rem(12px);
    letter-spacing: .5px;
  }

  .error {
    @include margin(null null 21px);
    color: $primary;
    font-size: rem(14px);
    letter-spacing: .5px;
  }

  .field {
    + .field {
      @include margin(18px null null);
    }
  }

  &-form {
    + .view-form {
      @include margin(40px null null);
    }

    &-actions {
      @include margin(24px null null);
    }
  }

  .btn {
    width: 100%;
  }

  .loader-container {
    @include position(absolute, 0 null null 0);
    @include size(100%);
    z-index: 1;
    background-color: rgba($grey-light, .6);
  }

  .loader {
    @include position(absolute, calc(50% - 30px) null null calc(50% - 30px));
  }
}
</style>
